// 中文文案 — 供 landing 组件 / slot 组件使用
// 与 en.ts 的 key 结构必须保持一致，TS 编译会强制检查
export const zh = {
  hero: {
    badge: "出海匠开放平台",
    titleLine1: "面向跨境电商从业者的",
    titleLine2: "一站式 API 服务平台",
    desc: "TikTok 电商数据 · AI 内容生产 · 社媒管理 · 广告营销，四大能力一个 API Key 直连，覆盖跨境电商内容营销完整链路。",
    ctaPrimary: "5 分钟快速开始",
    ctaSecondary: "申请 API Key",
    capabilityTags: {
      ecommerce: "电商数据",
      aiVideo: "AI 视频",
      social: "社媒管理",
      ads: "广告营销",
    },
    stats: {
      tiktokValue: "TikTok 全域",
      tiktokLabel: "商品 · 达人 · 视频 · 广告 · 直播",
      seedanceValue: "Seedance 2.0",
      seedanceLabel: "顶尖 AI 视频模型",
      multiPlatformValue: "多平台矩阵",
      multiPlatformLabel: "账号 · 发布 · 互动 · 数据",
    },
    // trenz 专用的 Hero 下方 stats row（数量型更有说服力）；出海匠未启用
    statsRow: {
      col1Value: "50M+",
      col1Label: "TikTok 商品",
      col2Value: "2M+",
      col2Label: "达人覆盖",
      col3Value: "< 30s",
      col3Label: "AI 视频生成",
    },
  },

  featureGrid: {
    ecommerce: {
      title: "TikTok 电商数据",
      desc: "商品、店铺、达人、视频、广告、直播多维搜索与详情查询，支持 30+ 排序筛选维度。",
      tags: ["商品搜索", "达人挖掘", "爆款视频", "直播数据"],
    },
    aiContent: {
      title: "AI 内容制作",
      desc: "视频生成（Seedance 2.0/Sora2/Veo3/Wan2.6）、图片生成、文案生成、视频分析、语音转文字全链路 AI 能力。",
      tags: ["视频生成", "图片生成", "文案创作", "语音转写"],
    },
    social: {
      title: "社媒管理",
      desc: "多平台账号管理、内容发布、评论互动、数据分析、发布计划，社媒运营全流程 API 化。",
      tags: ["多账号", "内容发布", "评论互动", "数据分析"],
    },
    ads: {
      title: "广告营销",
      desc: "TikTok 广告账户管理、广告效果洞察、落地页管理、线索管理，覆盖投放到转化全链路。",
      tags: ["账户管理", "效果洞察", "落地页", "线索收集"],
    },
  },

  quickStart: {
    eyebrow: "Quick Start",
    heading: "一个 curl 调用，看到第一个结果",
    copy: "复制",
    copied: "已复制",
    noApiKey: "还没有 API Key？",
    applyLink: "申请试用 →",
  },

  endpointShowcase: {
    eyebrow: "Featured Endpoints",
    heading: "从这几个端点开始",
    productsSearchDesc: "按关键词、国家、销量排序搜索 TikTok 商品",
    creatorsSearchDesc: "挖掘目标品类和国家的 TikTok 带货达人",
    sdProVideoDesc: "提交文生视频任务（Seedance 2.0 / Sora2 / Veo3）",
    socialAccountsDesc: "多平台社媒账号统一管理与列表查询",
  },

  siteHomeLink: {
    label: "出海匠官网",
  },

  sidebarHomeLink: {
    back: "返回",
  },
} as const;

export type Strings = typeof zh;
